export const featureLine = "stacks";

export enum StackAction {
  ARCHIVE = "ARCHIVE",
  CLONE = "CLONE",
  COLOR = "COLOR",
  COPY_LINK = "COPY_LINK",
  CUSTOM_COLOR = "CUSTOM_COLOR",
  DELETE = "DELETE",
  EDIT = "EDIT",
  LEAVE = "LEAVE",
  SUBSCRIBE = "SUBSCRIBE",
}
